import { render } from "./ShippingSource.vue?vue&type=template&id=42f0105b"
import script from "./ShippingSource.vue?vue&type=script&lang=ts"
export * from "./ShippingSource.vue?vue&type=script&lang=ts"
script.render = render

export default script